import { ReactElement } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import styles from './menu-link.module.scss';

interface Props {
    here: boolean;
    path: string;
    icon: ReactElement;
    label: string;
}

const MenuLink = (props: Props) => {
    return (
        <li
            className={classNames({
                [styles.item]: true,
                [styles.selected]: props.here,
            })}
        >
            <Link to={props.path}>
                {props.icon}
                {props.label}
            </Link>
        </li>
    );
};

export default MenuLink;
